import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-309402e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ap-input-group" }
const _hoisted_2 = { class: "ap-input-label lg c-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title", {}, undefined, true),
    (_ctx.editing)
      ? _renderSlot(_ctx.$slots, "default", {
          key: 0,
          class: "ap-input w-100"
        }, undefined, true)
      : _renderSlot(_ctx.$slots, "value", { key: 1 }, () => [
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.valueMapInternal ? _ctx.valueMapInternal[_ctx.value as any] || _ctx.value : _ctx.value), 1)
        ], true)
  ]))
}